var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-account"},[_c('div',{staticClass:"user-account ma-2"},[_c('user')],1),_c('div',{staticClass:"user-dids ma-2"},[_c('dids')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }